"use client"

import type React from "react"
import { styled } from "@mui/material/styles"
import Typography, { type TypographyProps } from "@mui/material/Typography"

interface CustomHeadingProps {
  text: string
  level: 1 | 2 | 3 | 4 | 5 | 6
}

// Properly typed styled component that accepts component prop
const StyledHeading = styled(Typography)<TypographyProps>({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px",
})

// Mapping object for better performance than switch statement
const headingComponents = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "h6",
} as const

const CustomHeading: React.FC<CustomHeadingProps> = ({ text, level }) => {
  return (
    <StyledHeading variant="body1" component={headingComponents[level]}>
      {text.trim()}
    </StyledHeading>
  )
}

export default CustomHeading
